// @ts-strict-ignore
import type { Module } from 'vuex'

import type { TaggingState } from '../../models'

import { TaggingTypeEnum } from '../../enums'

import { LoadActionsAction } from './actions/load-actions.action'
import { LoadViewsAction } from './actions/load-views.action'
import { SubmitFeedbackAction } from './actions/submit-feedback.action'
import { TagActionAction } from './actions/tag-action.action'
import { TagViewAction } from './actions/tag-view.action'
import { DataGetter } from './getters/data.getter'
import { DataMutation } from './mutations/data.mutation'
import { TAGGING_CONSTS } from './tagging.consts'

export const TAGGING_MODULE: Module<TaggingState, any> = {
  namespaced: true,

  initialState: (): TaggingState => ({
    data: {
      [TaggingTypeEnum.VIEW]: [],
      [TaggingTypeEnum.ACTION]: [],
    },
  }),
  state: (): TaggingState => TAGGING_MODULE.initialState(),

  getters: {
    [TAGGING_CONSTS.getters.data]: DataGetter.execute,
  },

  actions: {
    [TAGGING_CONSTS.actions.tagView]: TagViewAction.execute,
    [TAGGING_CONSTS.actions.tagAction]: TagActionAction.execute,
    [TAGGING_CONSTS.actions.loadViews]: LoadViewsAction.execute,
    [TAGGING_CONSTS.actions.loadActions]: LoadActionsAction.execute,

    [TAGGING_CONSTS.actions.submitFeedback]: SubmitFeedbackAction.execute,
  },

  mutations: {
    [TAGGING_CONSTS.mutations.setData]: DataMutation.execute,
  },
}
